import { uriRoles } from '@/router/uri-roles.ts'
import { routeNames } from '@/router/route-names.ts'
import type { SelectRouterItem } from '@/types'

export const cmSelectedRouterList: SelectRouterItem[] = [
  {
    value: 1,
    title: 'Danh sách nhà thầu',
    name: routeNames.ContractorList,
    uriRole: uriRoles.ContractorList,
    routeName: routeNames.ContractorList,
    disabled: false,
  },
]
